var util = {};
util.nowTime = function() {
  try {
    return parseInt(performance.now(), 10);
  } catch (e) {
    return new Date().getTime();
  }
};
util.concatData = function(video, audio) {
  var resBuffers = [];
  var bufferSize = 0;
  if (video) {
    resBuffers.push(video);
  }
  if (audio) {
    resBuffers.push(audio);
  }
  resBuffers.every(function(item) {
    item && (bufferSize += item.byteLength);
    return true;
  });
  var buffer = new Uint8Array(bufferSize);
  var offset = 0;
  resBuffers.every(function(item) {
    if (item) {
      buffer.set(item, offset);
      offset += item.byteLength;
    }
    return true;
  });
  return buffer;
};
export { util as default };
